export default __webpack_public_path__ + "static/media/Pyragon-tokenomics.4dddecf4.png";